/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import C4DCardCTA from '../cta/card-cta';
import styles from './feature-section.scss';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Feature Section Card Link.
 *
 * @element c4d-feature-section-card-link
 */
@customElement(`${c4dPrefix}-feature-section-card-link`)
class C4DFeatureSectionCardLink extends C4DCardCTA {
  static get stableSelector() {
    return `${c4dPrefix}--feature-section-card-link`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static get styles() {
    return css`
      ${super.styles}${styles}
    `;
  }
}

console.warn(
  'The feature-section-card-link component has been deprecated in favor of the card (link variant) component. ' +
    'See card documentation for more information.'
);

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DFeatureSectionCardLink;
